module.exports = __webpack_public_path__ + "img/banner.553bacb4.png";